import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import PostListItem from '../post-list-item';
import CreatePostCta from '../create-post-cta';
import InfiniteList from '../infinite-list';
import styles from './post-list.scss';

const THRESHOLD = 400;

const itemRenderer = props => index => {
  // eslint-disable-next-line react/prop-types
  const { category, posts, query, onLikeClick, showCreatePostAction } = props;

  if (showCreatePostAction && index === 0) {
    return (
      <div className={classNames(styles.listItemMobile)} key={'create-post'}>
        <CreatePostCta categorySlug={category.slug}/>
      </div>
    );
  }

  const post = posts[index - (showCreatePostAction ? 1 : 0)];
  return (
    <div className={classNames(styles.listItemMobile, 'post-list__post-list-item')} key={post._id} id={post._id}>
      <PostListItem post={post} query={query} onLikeClick={onLikeClick}/>
    </div>
  );
};

const PostListMobile = props => (
  <div data-hook="post-list">
    <InfiniteList
      length={props.posts.length + (props.showCreatePostAction ? 1 : 0)}
      itemRenderer={itemRenderer(props)} // Must pass props here otherwise it does not rerender after post change
      threshold={THRESHOLD}
    />
  </div>
);

PostListMobile.propTypes = {
  onLikeClick: PropTypes.func.isRequired,
  category: PropTypes.object,
  posts: PropTypes.array,
  location: PropTypes.object,
  query: PropTypes.string,
  showCreatePostAction: PropTypes.bool,
};

export default PostListMobile;



// WEBPACK FOOTER //
// ./app/components/post-list/post-list-mobile.js